import { CustomModulesIcon, FlexColumnIcon, GroupModuleIcon, PartialIcon } from 'foundations-assets';
export const DEFAULT_WIDGET_ICON = CustomModulesIcon;
export const WIDGET_ICON_MAP = Object.freeze({
  widget_container: FlexColumnIcon,
  cell: GroupModuleIcon,
  virtual_cell: FlexColumnIcon,
  global_group: PartialIcon,
  global_widget: DEFAULT_WIDGET_ICON,
  section_delimiter: DEFAULT_WIDGET_ICON
});